// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_cN25ln00J3hn8yA9Bz", // 3d
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/3csbJB5NkebQ8QUeVT", // 3d

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "3D Asset Gen 🎨",
    HOME_PAGE_TITLE: "Home - 3D Asset Gen 🎨",
    DASHBOARD_PAGE_TITLE: "Home - 3D Asset Gen 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to 3D Asset Gen 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate 3D assets, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "gen_3d_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/gen-3d-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;